import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'
import { ShiftAttributes } from '@/types'

interface Props extends BaseProps {
  defaultValues?: Partial<ShiftAttributes>
}

export const NewDialog = ({ defaultValues, open, setOpen }: Props) => {
  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>New shift</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
